export type AthleteTabSeoKey = 'streams' | 'media' | 'merch';

const TAB_TITLE_SUFFIX: Record<AthleteTabSeoKey, string> = {
  streams: 'Live Streams, PPVs & Replays',
  media: 'Videos, Photos & Media',
  merch: 'Official Merch',
};

export function getAthleteTabMetaTitle(
  athleteName: string,
  tab: AthleteTabSeoKey
): string {
  return `${athleteName} ${TAB_TITLE_SUFFIX[tab]} | MILLIONS`;
}

export type MemorabiliaTabSeo = { title: string; description: string };

// The /memorabilia tab now also shows stores that only have plain products
// (no signed items) — "signed memorabilia and collectibles" would be wrong
// copy for those pages, so pick copy based on what the store actually has.
export function getMemorabiliaTabSeo(
  athleteName: string,
  {
    hasMemorabilia,
    hasPureProducts,
  }: { hasMemorabilia: boolean; hasPureProducts: boolean }
): MemorabiliaTabSeo {
  if (!hasMemorabilia && hasPureProducts) {
    return {
      title: `${athleteName} Exclusive Products & Drops | MILLIONS`,
      description: `Browse ${athleteName}'s exclusive products on MILLIONS.`,
    };
  }

  return {
    title: `${athleteName} Signed Memorabilia & Collectibles | MILLIONS`,
    description: `Shop authentic signed ${athleteName} memorabilia and collectibles on MILLIONS.`,
  };
}
